import { useModal, Icons } from '@pankod/refine-antd'
import { Modal, Button, message, Radio, Collapse, List, Tag, Spin } from 'antd'
import { createInstantPaper, fillQuestionsFromAnotherSubsections, getAvailableSectionDetails } from 'helpers/paper/instantPaperCreation'
import { useState } from 'react'

const { Panel } = Collapse

interface ICreatePaper {
  request?: any
  userId: string
  refresh: any
}

interface Paper {
  paperId: number
  smartId: string
  uuid: string
  currentSubsectionId?: string
  assignedsubSectionId?: string
  paperRequestName?: string
}

interface ReusableSubSection {
  sectionName: string
  subSectionName: string
  subsectionId: string
  papers: Paper[]
}

interface Section {
  currentSubSectionSection: string
  currentSubSectionId: string
  currentSectionName: string
  reusableSubSections: ReusableSubSection[]
}

export const PaperCreateModal: React.FC<ICreatePaper> = ({ request, userId, refresh }) => {
  const { modalProps, show, close } = useModal()
  const [createLoading, setCreateLoading] = useState<boolean>(false)
  const [createInstantPaperLoading, setCreateInstantPaperLoading] = useState<boolean>(false)
  const [type, setType] = useState<string>('instant')
  const [selectedPapers, setSelectedPapers] = useState<any[]>([])
  const [activeSection, setActiveSection] = useState<string | string[]>('')
  const [loadingSubsectionSection, setLoadingSubsectionSection] = useState<boolean>(false)
  const [reusableSubSection, setReusableSubsections] = useState<any>([])

  const paperCreationTypes = [
    { label: 'Instant', value: 'instant' },
    { label: 'Get Subsections', value: 'suggestion' },
  ]

  const onInputClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const element = event.target as HTMLInputElement
    element.value = ''
  }

  const createPaper = async (e: any) => {
    try {
      setCreateLoading(true)
      const response = await createInstantPaper(e, request, userId)
      if (response && response.status) {
        message.success('Paper generation completed')
      } else {
        message.error('Unable to finish the paper creation please try again!')
      }
    } catch (err) {
      message.error('Unable to create the paper, please try again later!')
    } finally {
      refresh()
      setCreateLoading(false)
      close()
    }
  }

  const createPaperWithSelectedSubsectiion = async () => {
    try {
      setCreateInstantPaperLoading(true)
      const getPaperDetails = await fillQuestionsFromAnotherSubsections(selectedPapers, request, userId)
      if (getPaperDetails) {
        message.success('Paper created Successfully')
      } else {
        message.error('Unable to complete the paper creation')
      }
    } catch (err) {
      console.log(err)
    } finally {
      refresh()
      setCreateInstantPaperLoading(false)
      setSelectedPapers([])
      close()
    }
  }

  const handlePaperSelect = (paper: any, sectionName: string, sectionId: string) => {
    // Check if there's already a selected paper from this section
    const existingSelection = selectedPapers.find((p: any) => p.sectionId === sectionId)
    console.log(selectedPapers, 'Selected Papers')
    if (existingSelection) {
      // Replace the existing paper for that section
      setSelectedPapers(prev => prev.map(p => (p.sectionId === sectionId ? { ...paper, sectionName, sectionId } : p)))
    } else {
      // No selection yet from this section — add the new one
      setSelectedPapers(prev => [...prev, { ...paper, sectionName, sectionId }])
    }
  }

  const handlePaperRemove = (paper: any) => {
    setSelectedPapers(prev => prev.filter(p => !(p.paperId === paper.paperId && p.sectionId === paper.sectionId)))
  }

  return (
    <>
      <Button icon={<Icons.PlusOutlined />} type="primary" loading={createLoading} onClick={show} style={{ cursor: 'pointer' }}>
        Create Instant Paper
      </Button>
      <Modal {...modalProps} title="Create Paper" onCancel={close} footer={null} okText="Create" width={'80%'}>
        <div style={{ marginBottom: '1rem', textAlign: 'right' }}>
          <Radio.Group
            value={type}
            onChange={async e => {
              setType(e.target.value)
              if (e.target.value === 'suggestion') {
                setLoadingSubsectionSection(true)
                const sectionDetails = await getAvailableSectionDetails(request)
                if (sectionDetails && sectionDetails.length > 0) {
                  console.log(sectionDetails, 'Section Details')
                  setReusableSubsections(sectionDetails)
                }
              }
              setLoadingSubsectionSection(false)
              setSelectedPapers([])
            }}
            size="small"
          >
            {paperCreationTypes.map(type => (
              <Radio.Button key={type.value} value={type.value}>
                {type.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        {type === 'instant' ? (
          <div className="upload-btn-wrapper1">
            <button disabled={createLoading} className="btnshow">
              {createLoading ? 'Loading...' : 'Create Instant paper'}
            </button>
            <input type="file" name="myfile" id={'csvFileInput'} accept={'.csv'} onChange={(e: any) => createPaper(e)} onClick={onInputClick} />
          </div>
        ) : (
          <>
            {loadingSubsectionSection ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <Spin tip="Hold on, we are finding the possible subsections." />
              </div>
            ) : (
              <>
                {!loadingSubsectionSection && reusableSubSection && reusableSubSection.length > 0 ? (
                  <div>
                    <Collapse activeKey={activeSection} onChange={setActiveSection} style={{ marginBottom: '1rem' }}>
                      {reusableSubSection.map((section: any) => (
                        <Panel header={section.sectionName} key={section.sectionId}>
                          {section.reusablesections.map((paper: any) => (
                            <div key={`${paper.paperId}-${section.sectionId}`} style={{ marginBottom: '0.5rem' }}>
                              <Button
                                type="link"
                                onClick={() => handlePaperSelect(paper, section.sectionName, section.sectionId)}
                                disabled={selectedPapers.some((p: any) => p.paperId === paper.paperId && p.sectionId === section.sectionId)}
                              >
                                Paper ID: {paper.paper_serial_number} (Smart ID: {paper.paperSmartId})
                              </Button>
                            </div>
                          ))}
                        </Panel>
                      ))}
                    </Collapse>

                    {selectedPapers.length > 0 && (
                      <div>
                        <h3>Selected Papers:</h3>
                        <List
                          dataSource={selectedPapers}
                          renderItem={paper => (
                            <List.Item>
                              <div>
                                <h4>{paper.sectionName}</h4>
                                <Tag
                                  closable
                                  onClose={e => {
                                    e.preventDefault()
                                    handlePaperRemove(paper)
                                  }}
                                >
                                  Paper ID:{paper.paper_serial_number} (Smart ID: {paper.paperSmartId})
                                </Tag>
                              </div>
                            </List.Item>
                          )}
                        />
                      </div>
                    )}
                    <Button
                      type="primary"
                      loading={createInstantPaperLoading}
                      disabled={selectedPapers.length === 0 || createLoading}
                      onClick={() => createPaperWithSelectedSubsectiion()}
                      style={{ marginTop: '1rem' }}
                    >
                      Create Paper with Selected Subsections
                    </Button>
                  </div>
                ) : (
                  <p>No Data!</p>
                )}
              </>
            )}
          </>
        )}
      </Modal>
    </>
  )
}

export default PaperCreateModal
